module.exports = __webpack_public_path__ + "img/high.96c80290.svg";